module.exports = __webpack_public_path__ + "static/media/banner_left_shap.0f6104be.png";